import { useEffect, useState } from "react";
import { api } from "../lib/api";
import { PageHeader } from "../components/Primitives";
import Pagination, { usePagination } from "../components/Pagination";
import { useApiLoading, LoadingRow } from "../components/TableLoader";

export default function AuditLogs() {
    const [rows, setRows] = useState([]);
    const apiLoading = useApiLoading();
    const [filter, setFilter] = useState({ entity: "", action: "" });

    const load = async () => {
        const params = {};
        if (filter.entity) params.entity = filter.entity;
        if (filter.action) params.action = filter.action;
        const { data } = await api.get("/audit-logs", { params });
        setRows(data);
    };
    useEffect(() => { load(); }, [filter]); // eslint-disable-line

    const pager = usePagination(rows, 50);

    return (
        <div data-testid="audit-logs-page">
            <PageHeader eyebrow="Security" title="Audit logs" subtitle="Every commercial edit, assignment change, branding update, and export run." />

            <div className="flex gap-3 mb-5">
                <select value={filter.entity} onChange={(e) => setFilter({ ...filter, entity: e.target.value })} className="px-3 py-2 bg-zinc-100 border border-zinc-200 rounded text-sm" data-testid="audit-entity-filter">
                    <option value="">All entities</option>
                    <option value="campaign_commercial">Commercial settings</option>
                    <option value="ad_account_assignment">Assignment</option>
                    <option value="agency_branding">Agency branding</option>
                    <option value="advertiser_branding">Advertiser branding</option>
                    <option value="export_schedule">Schedule</option>
                    <option value="report_export">Export</option>
                    <option value="platform_connection">Integration</option>
                </select>
                <select value={filter.action} onChange={(e) => setFilter({ ...filter, action: e.target.value })} className="px-3 py-2 bg-zinc-100 border border-zinc-200 rounded text-sm">
                    <option value="">All actions</option>
                    <option value="create">create</option>
                    <option value="update">update</option>
                    <option value="delete">delete</option>
                    <option value="assign">assign</option>
                    <option value="sync">sync</option>
                    <option value="run">run</option>
                </select>
            </div>

            <div className="bg-white border border-zinc-200 overflow-x-auto">
                <table className="w-full text-sm">
                    <thead>
                        <tr className="bg-zinc-100 border-b border-zinc-200">
                            <th className="overline text-left p-3">Time</th>
                            <th className="overline text-left p-3">User</th>
                            <th className="overline text-left p-3">Entity</th>
                            <th className="overline text-left p-3">Action</th>
                            <th className="overline text-left p-3">Details</th>
                        </tr>
                    </thead>
                    <tbody>
                        {pager.slice.map((r) => (
                            <tr key={r.id} className="border-b border-zinc-200 last:border-0">
                                <td className="p-3 text-zinc-500 text-xs">{new Date(r.created_at).toLocaleString()}</td>
                                <td className="p-3 text-zinc-800 text-xs">{r.user_email || "—"}</td>
                                <td className="p-3"><span className="px-2 py-0.5 rounded bg-zinc-100 border border-zinc-200 text-xs text-zinc-700">{r.entity}</span></td>
                                <td className="p-3 text-zinc-700 text-xs uppercase">{r.action}</td>
                                <td className="p-3 text-zinc-500 text-xs font-mono">{r.details_json ? JSON.stringify(r.details_json) : "—"}</td>
                            </tr>
                        ))}
                        {!rows.length && (apiLoading ? <LoadingRow colSpan={5} /> : <tr><td colSpan={5} className="p-10 text-center text-zinc-500">No audit entries.</td></tr>)}
                    </tbody>
                </table>
                {rows.length > 0 && (
                    <Pagination
                        page={pager.page}
                        totalPages={pager.totalPages}
                        pageSize={pager.pageSize}
                        range={pager.range}
                        setPage={pager.setPage}
                        setPageSize={pager.setPageSize}
                        dataTestId="audit-pagination"
                    />
                )}
            </div>
        </div>
    );
}
